// extracted by mini-css-extract-plugin
export default {"PropertyPrice":"PropertyPrice_PropertyPrice__8FNFt"};